var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessagesFilled = function SvgMessagesFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Messages Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-(Results)-Messageing",
    transform: "translate(-253.000000, -237.000000)",
    fill: "#343754",
    stroke: "#343754",
    strokeWidth: 1.964042
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(236.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-messages-inactive",
    transform: "translate(18.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4560873,16.5468831 C16.6020909,16.9337426 16.8410876,17.2282043 17.1315009,17.4793567 C17.3100728,17.6338638 17.5052754,17.7702673 17.7007552,17.9031894 C17.8863952,18.0294271 18.0147286,18.1863015 17.9848626,18.4193503 C17.9545809,18.6562287 17.8022716,18.7905434 17.5751243,18.8587103 C16.8626382,19.0724022 16.1410052,19.1242063 15.4032267,19.0297891 C14.5285915,18.9177558 13.7506221,18.5873655 13.0664082,18.0317944 C12.9634365,17.9482395 12.8597027,17.8610638 12.7759256,17.7592659 C12.6756565,17.6374845 12.560489,17.6101203 12.4122681,17.6267616 C11.5607079,17.7222232 10.7068611,17.7280024 9.85405363,17.6575377 C7.93750628,17.4989225 6.13536416,16.9628476 4.4786712,15.9694485 C3.22776684,15.2192639 2.16083939,14.2679904 1.37718786,13.0217678 C0.598941305,11.7841095 0.205972182,10.4378994 0.284967915,8.9656605 C0.372486872,7.33543306 1.00514568,5.92934188 2.04872088,4.70101393 C3.36337618,3.15357555 5.04085749,2.16191711 6.94964386,1.54938942 C8.48465567,1.05683277 10.0613135,0.859434109 11.6740737,0.943963905 C13.5046959,1.03984325 15.249185,1.46492925 16.8821099,2.30744205 C18.5051258,3.14480228 19.8587939,4.2897145 20.7872709,5.89236879 C21.5093196,7.13866106 21.8282129,8.48584598 21.6956525,9.92494139 C21.5709224,11.2788803 21.0636867,12.4889654 20.2478132,13.568844 C19.3118524,14.8076164 18.1172844,15.725816 16.7348591,16.4080425 C16.6476173,16.4512126 16.5605834,16.4948701 16.4560873,16.5468831",
    id: "Messages-Icon"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessagesFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messages-filled.d250f7f9.svg";
export { ForwardRef as ReactComponent };